//component 
import CustomRating from '../elements/input/custom-rating'
import CustomText from '../elements/input/custom-text'
import CustomTextArea from '../elements/input/custom-textarea'
import CustomSurveyQualification from '../elements/input/custom-survey-qualification'
import Checkbox from '../elements/checkbox'
import ActionButton from '../elements/button/action-button'
import DeleteButton from '../elements/button/delete-button'
import Message from '../elements/custom-alert'
import Loading from '../controls/loading'

//style
import '../styles/custom-survey.css'

const CustomSurvey = ({
    propertyRate,
    photoRate,
    communicationRate,
    priceQualityRate,
    title,
    comment,
    reviewed,
    surveyQualification,
    allowUserCheck,
    isAdmin,
    isReviewed,
    loading,
    setPhotoRate,
    setPropertyRate,
    setPriceQualityRate,
    setCommunicationRate,
    setComment,
    setTitle,
    setAllowUserCheck,
    setSurveyQualification,
    sendReview,
    sendPublishReview,
    sendSpamReview
    }) => {

  return (
    <>
    {
      reviewed ? 
      <div style={{width:'fit-content'}}>
      <Message>
          Thank you for your Review! <br/>
          It will be published as soon as be moderated and will help other users for future.
      </Message>
      </div>
      :
      <div className={`custom-survey__content ${isAdmin ? 'custom-survey__content__noBackground' : ''}`}>
        <div className='custom-survey__content__information' style={isAdmin ? {pointerEvents:'none'} : {}}>
          <CustomSurveyQualification labelSize="115px" label="Rate Your Stay" value={surveyQualification} setValue={setSurveyQualification}/>
          <div className='custom-survey__content__star-section'>
            <div className='custom-survey__content__star-section__1'>
              <CustomRating label="Property" labelSize="115px" value={propertyRate} setValue={setPropertyRate}/>
              <CustomRating label="Communication" labelSize="115px" value={communicationRate} setValue={setCommunicationRate}/>
            </div>
            <div className='custom-survey__content__star-section__2'>
              <CustomRating label="Photo" labelSize="115px" value={photoRate} setValue={setPhotoRate}/>
              <CustomRating label="Price&Quality" labelSize="115px" value={priceQualityRate} setValue={setPriceQualityRate}/>
            </div>
          </div>
          
          <CustomText label="Title" labelSize="115px" value={title} setValue={setTitle} isText={isAdmin} requiredValue={true}/>
          <CustomTextArea label={isAdmin ? 'Comment' : 'Your Comment'} labelSize="115px" value={comment ? comment : (isAdmin ? '-' : comment)} setValue={setComment} isText={isAdmin} requiredValue={true}/>
          <div className='custom-survey__content__space'>
              <Checkbox checkValue={allowUserCheck} onChange={(id,value)=>setAllowUserCheck(value)} label="I allow to publish my review"/>
          </div>
        </div>

        <div className='custom-survey__content__space' >
            {
              isAdmin ?
              (
                isReviewed ?
                <Message>
                  It has already been reviewed.
                </Message>
                :
                <>
                  <Loading isVisble={loading}/>
                  <ActionButton disabled={loading} action={sendPublishReview}>
                    Publish the Review
                  </ActionButton>
                  <DeleteButton disabled={loading} action={sendSpamReview}>
                    Mark as a spam
                  </DeleteButton>
                </>
              )
              :
              <>
                  <Loading isVisble={loading}/>
                  <ActionButton action={sendReview} disabled={loading}>
                    Submit a Review
                  </ActionButton>
                  <span className='custom-survey__content__comment'>Your feedback is important and will help the property improve its services</span>
              </>
            }
            
        </div>
    </div>
    }
    </>
  )
}

export default CustomSurvey